import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import IndexHome from "../../screens/home/index";
import Login from "../../screens/login";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useIdleTimeout } from "../../hooks/useIdleTimeOut";

const AppHome = () => {
  const isAuthenticated = useIsAuthenticated();

  const { accounts } = useMsal();

  useIdleTimeout(isAuthenticated ? 3600000 : null);

  useEffect(() => {
    if (accounts.length > 0) {
      sessionStorage.setItem(
        "user-details",
        JSON.stringify({
          name: accounts.length > 0 && accounts[0].name,
          email: accounts.length > 0 && accounts[0].username,
          token: accounts.length > 0 && accounts[0].idToken,
        }),
      );
    } else {
      console.log(
        "Desde AD cloud no se han obtenido cuentas asociadas al email del usuario autenticado",
      );
    }
  }, [accounts]);

  const validateLoginUser = () => {
    return (
      <Route
        path="*"
        element={
          isAuthenticated ? (
            <AuthenticatedTemplate>
              <IndexHome />
            </AuthenticatedTemplate>
          ) : (
            <UnauthenticatedTemplate>
              <Login />
            </UnauthenticatedTemplate>
          )
        }
      />
    );
    //<Route path="*" element={<Error500 />} />
  };

  return <Routes>{validateLoginUser()}</Routes>;
};

export default AppHome;
